import type React from "react";
import { Chip } from "@mui/material";

interface SourceChipProps {
  source?: "MANUAL" | "LOGISLY";
}

const SourceChip: React.FC<SourceChipProps> = ({ source }) => {
  const normalized = source ?? "MANUAL";

  return (
    <Chip
      size="small"
      label={normalized === "LOGISLY" ? "Created from Logisly" : "Manual"}
      color={normalized === "LOGISLY" ? "warning" : "default"}
      variant={normalized === "LOGISLY" ? "filled" : "outlined"}
    />
  );
};

export default SourceChip;
